
//import { __callbacks } from "Utils/Callbacks/Callback";
//import React, { useEffect } from 'react'
import styles from "./Text.module.scss";

export default function Text(props) {

  // useEffect(() => {
  //   __callbacks.messageText.trigger({
  //     props: (props.text ?? props.children)
  //   });
  // }, []);

  return (
    <div className={styles.container} dangerouslySetInnerHTML={{ __html: (props.text ?? props.children) }}></div>
  )
}
